import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ShopPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('全部');

  useEffect(() => {
    // Update page title and meta
    document.title = '線上購物 - Flan Cake 芙蘭蛋糕 | 經典原味、咖啡、抹茶多種口味';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '芙蘭蛋糕線上購物，提供經典原味、濃郁咖啡、抹茶紅豆、芒果椰奶、草莓奶油、黑糖珍珠、巧克力榛果、香草蜂蜜等多種口味。每一口都是幸福滋味，首次購物享9折優惠。');
    }

    // Add Schema.org JSON-LD for Product listing
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Flan Cake 線上購物",
      "description": "精選多款 Flan Cake，每一口都是幸福滋味",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/shop`,
      "mainEntity": {
        "@type": "ItemList",
        "itemListElement": [
          {
            "@type": "Product",
            "name": "經典原味 Flan Cake",
            "description": "最經典的焦糖布丁蛋糕，絲滑細膩",
            "offers": {
              "@type": "Offer",
              "price": "380",
              "priceCurrency": "TWD"
            }
          },
          {
            "@type": "Product",
            "name": "濃郁咖啡 Flan Cake",
            "description": "加入精選咖啡豆，香醇濃郁",
            "offers": {
              "@type": "Offer",
              "price": "420",
              "priceCurrency": "TWD"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Flan Cake 芙蘭蛋糕，源自南美洲的經典甜點，絲滑細膩的口感與濃郁焦糖香氣。提供線上購物、門市洽詢與加盟服務，將百年傳承的南美甜蜜帶到台灣。芙蘭蛋糕專賣店提供經典原味、咖啡、抹茶等多種口味，台北、台中、高雄、台南門市籌備中。');
      }
    };
  }, []);

  const categories = ['全部', '經典系列', '創新口味', '季節限定'];

  const products = [
    {
      name: '經典原味 Flan Cake',
      category: '經典系列',
      price: 'NT$ 380',
      description: '最經典的焦糖布丁蛋糕，絲滑細膩',
      image: 'https://public.readdy.ai/ai/img_res/2b25e877a9b0af3e6f054953829c390f.jpg',
    },
    {
      name: '濃郁咖啡 Flan Cake',
      category: '創新口味',
      price: 'NT$ 420',
      description: '加入精選咖啡豆，香醇濃郁',
      image: 'https://readdy.ai/api/search-image?query=Coffee%20flavored%20flan%20cake%20with%20espresso%20caramel%20sauce%20and%20coffee%20bean%20garnish%20on%20white%20plate%2C%20rich%20brown%20color%2C%20professional%20food%20photography%2C%20clean%20background%2C%20elegant%20presentation&width=600&height=600&seq=product-coffee&orientation=squarish',
    },
    {
      name: '抹茶紅豆 Flan Cake',
      category: '創新口味',
      price: 'NT$ 450',
      description: '日式風味結合南美經典',
      image: 'https://readdy.ai/api/search-image?query=Matcha%20green%20tea%20flan%20cake%20with%20sweet%20red%20beans%20topping%20on%20white%20plate%2C%20beautiful%20green%20color%20gradient%2C%20professional%20food%20photography%2C%20minimalist%20presentation%2C%20clean%20white%20background&width=600&height=600&seq=product-matcha&orientation=squarish',
    },
    {
      name: '芒果椰奶 Flan Cake',
      category: '季節限定',
      price: 'NT$ 480',
      description: '熱帶風情，夏日限定',
      image: 'https://readdy.ai/api/search-image?query=Tropical%20mango%20coconut%20flan%20cake%20with%20fresh%20mango%20slices%20and%20coconut%20flakes%20on%20white%20plate%2C%20vibrant%20yellow%20and%20white%20colors%2C%20professional%20food%20photography%2C%20summer%20vibe%2C%20clean%20background&width=600&height=600&seq=product-mango&orientation=squarish',
    },
    {
      name: '草莓奶油 Flan Cake',
      category: '季節限定',
      price: 'NT$ 460',
      description: '新鮮草莓，春季限定',
      image: 'https://readdy.ai/api/search-image?query=Strawberry%20cream%20flan%20cake%20topped%20with%20fresh%20strawberries%20and%20whipped%20cream%20on%20white%20plate%2C%20pink%20and%20white%20colors%2C%20professional%20food%20photography%2C%20romantic%20presentation%2C%20clean%20background&width=600&height=600&seq=product-strawberry&orientation=squarish',
    },
    {
      name: '黑糖珍珠 Flan Cake',
      category: '創新口味',
      price: 'NT$ 440',
      description: '台灣特色，黑糖珍珠點綴',
      image: 'https://readdy.ai/api/search-image?query=Brown%20sugar%20boba%20flan%20cake%20with%20chewy%20tapioca%20pearls%20and%20dark%20caramel%20sauce%20on%20white%20plate%2C%20professional%20food%20photography%2C%20Taiwanese%20fusion%20dessert%2C%20clean%20background&width=600&height=600&seq=product-boba&orientation=squarish',
    },
    {
      name: '巧克力榛果 Flan Cake',
      category: '經典系列',
      price: 'NT$ 420',
      description: '濃郁巧克力與香脆榛果',
      image: 'https://readdy.ai/api/search-image?query=Chocolate%20hazelnut%20flan%20cake%20with%20crushed%20hazelnuts%20and%20chocolate%20sauce%20on%20white%20plate%2C%20rich%20dark%20brown%20color%2C%20professional%20food%20photography%2C%20luxurious%20presentation%2C%20clean%20background&width=600&height=600&seq=product-chocolate&orientation=squarish',
    },
    {
      name: '香草蜂蜜 Flan Cake',
      category: '經典系列',
      price: 'NT$ 400',
      description: '天然香草與純淨蜂蜜',
      image: 'https://readdy.ai/api/search-image?query=Vanilla%20honey%20flan%20cake%20with%20vanilla%20bean%20specks%20and%20honey%20drizzle%20on%20white%20plate%2C%20golden%20color%2C%20professional%20food%20photography%2C%20natural%20and%20pure%20presentation%2C%20clean%20background&width=600&height=600&seq=product-vanilla&orientation=squarish',
    },
  ];

  const filteredProducts = selectedCategory === '全部' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen bg-lavender-50">
      <Navbar />
      <main className="pt-32 pb-24">
        <section className="px-6 mb-16">
          <div className="max-w-7xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-800 mb-6">
              線上購物
            </h1>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto">
              精選多款 Flan Cake，每一口都是幸福滋味
            </p>
          </div>
        </section>

        <section className="px-6 mb-12">
          <div className="max-w-7xl mx-auto">
            <div className="flex justify-center gap-4 flex-wrap">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-lavender-600 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-lavender-100'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="px-6" data-product-shop>
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {filteredProducts.map((product, index) => (
                <div
                  key={index}
                  className="group cursor-pointer"
                >
                  <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                    <div className="relative h-64 overflow-hidden bg-lavender-100">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6 space-y-3">
                      <div className="text-xs text-lavender-700 font-medium">
                        {product.category}
                      </div>
                      <h3 className="text-lg font-semibold text-gray-800">
                        {product.name}
                      </h3>
                      <p className="text-sm text-gray-600">
                        {product.description}
                      </p>
                      <div className="flex items-center justify-between pt-3">
                        <span className="text-xl font-bold text-lavender-700">
                          {product.price}
                        </span>
                        <button className="w-10 h-10 flex items-center justify-center bg-lavender-600 text-white rounded-full hover:bg-lavender-500 transition-colors cursor-pointer">
                          <i className="ri-shopping-cart-line"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-6 mt-24">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl p-12 text-center shadow-lg">
            <i className="ri-gift-line text-5xl text-lavender-600 mb-6"></i>
            <h3 className="text-3xl font-serif font-bold text-gray-800 mb-4">
              首次購物享 9 折優惠
            </h3>
            <p className="text-gray-600 mb-8">
              立即註冊會員，即可獲得專屬優惠碼
            </p>
            <button className="inline-flex items-center gap-2 bg-lavender-600 text-white px-8 py-4 rounded-full font-medium hover:bg-lavender-500 transition-all shadow-lg whitespace-nowrap cursor-pointer">
              立即註冊
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ShopPage;
